<ngb-carousel 
    id="uniCarousel" 
    interval="0" 
    [pauseOnHover]="false" 
    [showNavigationIndicators]="false"
    [showNavigationArrows]="true"
    [keyboard]="true"
    [animation]="false"
>

    <ng-template ngbSlide *ngFor="let kpi of globalKpiEnv">
        <app-global-kpi-env 
            [companyType]="kpi.companyType"
            [header]="kpi.header"
        />
    </ng-template>
</ngb-carousel>
